// Functional video green-screen value. NOT a UI palette color.
// Use only inside the chroma-key feature (Creator3D background, ThreeJS scene clear color).
// Do not reference from any UI styling, modals, status indicators, etc.
export const CHROMA_KEY_GREEN = '#00ff00';
